// extracted by mini-css-extract-plugin
export var circle_container = "circle_container-SjN";
export var image = "image-rA3";
export var svg_wrapper = "svg_wrapper-k+k";